// extracted by mini-css-extract-plugin
export var aboveInput = "_lv-0";
export var actionButton = "_lv-5";
export var actionButtonContainer = "_lv-1";
export var actionIcon = "_lv-6";
export var aiInfoContainer = "_lv-2";
export var attachmentWrapper = "_lv-7";
export var bold = "_lv-3";
export var checkIcon = "_lv-8";
export var clickingRecipientBar = "_lv-11";
export var commentThreadSwitch = "_lv-a";
export var draftImage = "_lv-b";
export var draftImageContainer = "_lv-c";
export var draftImages = "_lv-e";
export var editButton = "_lv-g";
export var editor = "_lv-f";
export var editorContainer = "_lv-y";
export var editorErrorTooltipWrapper = "_lv-9";
export var headerDivider = "_lv-h";
export var icon = "_lv-i";
export var info = "_lv-j";
export var internal = "_lv-n";
export var internalDivider = "_lv-k";
export var internalMessage = "_lv-l";
export var messageInputCard = "_lv-m";
export var messageInputForm = "_lv-o";
export var messageInputFormInternal = "_lv-p";
export var options = "_lv-q";
export var publicMessageCustomer = "_lv-s";
export var publicMessageMerchant = "_lv-r";
export var removeImageButton = "_lv-d";
export var replyButtons = "_lv-t";
export var showSignatureButton = "_lv-u";
export var spinner = "_lv-v";
export var verticalButtonDivider = "_lv-4";
export var visibilitySelector = "_lv-w";
export var warning = "_lv-x";
export var wrappingText = "_lv-z";
export var writingInternalNoteTopBorder = "_lv-10";